import React from 'react';
import PropTypes from 'prop-types';

import { MaterialIcon } from '@pearsontechnology/aero-components';
import UserProfile from 'components/UserProfile';
import Link from 'data/Link';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { toggleMobileSidebar } from 'containers/App/actions';
import { makeSelectMobileSidebarOpen } from 'containers/App/selectors';


import Breadcrumbs from '../Breadcrumbs';
import { Header, Title, HeaderActions, HeaderMenuButton, UpdatedTitle, LineBreakContainer, LineBreak } from './styles';
import { featureKeys } from 'services/FeatureFlagService';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';

const WorkspaceHeader = ({ title, children, links, bgColor, mobileSidebarOpen, toggleSidebar, workspaceRedesign, getFeatureFlagValue}) => (
<>
  <Header>
    <HeaderMenuButton
      grey
      rounded
      iconOnly
      aria-label="Menu"
      aria-expanded={mobileSidebarOpen}
      onClick={() => toggleSidebar()}
    >
      <MaterialIcon id="menu" />
    </HeaderMenuButton>
    <span>
      { links && <Breadcrumbs links={links} /> }
      { title && getFeatureFlagValue(featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22) ? <Title as={UpdatedTitle} workspaceRedesign={workspaceRedesign}>{title}</Title> 
        : <Title bgColor={bgColor} workspaceRedesign={workspaceRedesign}>{title}</Title> }
    </span>
    <HeaderActions>
      { children }
      <UserProfile style={{ marginRight: 0 }} />
    </HeaderActions>
  </Header>
  {workspaceRedesign && 
  <LineBreakContainer> 
    <LineBreak /> 
  </LineBreakContainer> 
  }
</>
);

WorkspaceHeader.propTypes = {
  title: PropTypes.node,
  children: PropTypes.any,
  links: PropTypes.arrayOf(PropTypes.instanceOf(Link)),
  bgColor: PropTypes.string,
  mobileSidebarOpen: PropTypes.bool,
  toggleSidebar: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  mobileSidebarOpen: makeSelectMobileSidebarOpen(),
});

export function mapDispatchToProps(dispatch) { // Exported for testing purposes.
  return {
    dispatch,
    toggleSidebar: (value) => dispatch(toggleMobileSidebar(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const flagNames = [featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22];
export default compose(withConnect, enhanceWithFeatureFlagSubscription)(WorkspaceHeader, flagNames);
